<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <div
        :class="[
            'body-xs flex w-full flex-col gap-2 leading-tight lg:gap-3',
            props.class,
        ]"
    >
        <p>
            &copy; {{ new Date().getFullYear() }} Expedia Group &amp;
            iShowSpeed. All rights reserved.
        </p>
        <div class="flex flex-wrap gap-3">
            <router-link
                :to="{ name: 'about' }"
                class="faded-text uppercase underline transition-opacity hover:opacity-100"
            >
                About
            </router-link>
            <a
                href="https://www.expedia.com/lp/b/terms-of-service"
                target="_blank"
                class="faded-text uppercase underline transition-opacity hover:opacity-100"
            >
                Terms and Conditions
            </a>
            <a
                href="https://www.expedia.com/legal/privacy"
                target="_blank"
                class="faded-text uppercase underline transition-opacity hover:opacity-100"
            >
                Privacy Policy
            </a>
            <button
                id="ot-sdk-btn"
                class="ot-sdk-show-settings faded-text uppercase underline transition-opacity hover:opacity-100"
            >
                Cookie Settings
            </button>
            <a
                href="mailto:ishowspeed@expediagroup.com"
                class="faded-text uppercase underline transition-opacity hover:opacity-100"
            >
                Contact Us
            </a>
        </div>
    </div>
</template>

<style scoped>
:deep(#ot-sdk-btn.ot-sdk-show-settings) {
    background: transparent;
    color: inherit;
    height: auto;
    white-space: inherit;
    word-wrap: inherit;
    padding: 0;
    font-size: inherit;
    line-height: inherit;
}
</style>
